import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { useSingleExecutionFunction } from '@noths/polaris-client-react-hooks';
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem, visuallyHidden } from '@noths/polaris-client-styles';
import * as styles from "./DepartmentsNavItem.styles";
import { useTracking } from "../DepartmentsNav/hooks/useTracking/useTracking";
import { MegaNav } from "../MegaNav/MegaNav";
import { ProgressiveDisclosureMegaNav } from "../ProgressiveDisclosureMegaNav/ProgressiveDisclosureMegaNav";
import { GlobalNavigation } from "../../../constants/featureFlags";
import { useSiteChromeStaticContext } from "../../../context/SiteChromeStaticContext/useSiteChromeStaticContext";
var NAV_OPEN_DELAY = 200;
export var DepartmentsNavItem = function DepartmentsNavItem(_ref) {
  var department = _ref.department,
    index = _ref.index,
    openIndex = _ref.openIndex,
    seo = _ref.seo,
    setNavClosed = _ref.setNavClosed,
    setNavOpen = _ref.setNavOpen,
    setRef = _ref.setRef;
  var isThisDeptNavOpen = openIndex === index;
  var isAnyDeptNavOpen = openIndex !== -1;
  var color = department.color,
    columns = department.columns,
    seoLinks = department.seoLinks,
    title = department.title,
    url = department.url;
  var hasChildren = columns.length > 0;
  var tracking = useTracking();
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    globalNavigation = _useSiteChromeStaticC.globalNavigation;
  var timeout;
  var trackMouseEnterOnce = useSingleExecutionFunction(function () {
    return tracking.onHoverLink(index, department);
  });
  var setNavOpenWithTimeout = function setNavOpenWithTimeout() {
    timeout = window.setTimeout(function () {
      setNavOpen(index);
      trackMouseEnterOnce();
    }, NAV_OPEN_DELAY);
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (globalNavigation === GlobalNavigation.PROGRESSIVE_DISCLOSURE) {
      return;
    }
    if (isAnyDeptNavOpen) {
      setNavOpen(index);
      trackMouseEnterOnce();
    } else {
      setNavOpenWithTimeout();
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (globalNavigation === GlobalNavigation.PROGRESSIVE_DISCLOSURE) {
      return;
    }
    clearTimeout(timeout);
    setNavClosed();
  };
  var handleBlur = function handleBlur(e) {
    var focusIsStillWithinThisDept = e.currentTarget.contains(e.relatedTarget);
    if (!focusIsStillWithinThisDept) {
      setNavClosed();
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Escape') {
      setNavClosed();
    }
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      if (isThisDeptNavOpen) {
        setNavClosed();
      } else {
        setNavOpen(index);
      }
    }
  };
  var handleClick = function handleClick(e) {
    if (globalNavigation === GlobalNavigation.PROGRESSIVE_DISCLOSURE) {
      e.preventDefault();
      if (isThisDeptNavOpen) {
        setNavClosed();
      } else {
        setNavOpen(index);
        trackMouseEnterOnce();
      }
    } else {
      tracking.onClickLink(e, department);
    }
  };
  return /*#__PURE__*/React.createElement(_StyledLi, {
    key: index,
    onBlur: handleBlur,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    style: {
      '--department-link-color': color || 'inherit',
      '--horizontal-padding': pxToRem(theme.spacing.lg)
    },
    $_css: styles.item
  }, /*#__PURE__*/React.createElement(_StyledA, {
    "data-active": isThisDeptNavOpen,
    href: url,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    ref: setRef,
    rel: seo === 'exclude' ? 'nofollow' : undefined,
    $_css2: styles.link
  }, title), hasChildren && /*#__PURE__*/React.createElement(_StyledDiv, null, seoLinks.map(function (link, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("a", {
        href: link.url,
        key: index,
        tabIndex: -1
      }, link.title)
    );
  })), hasChildren && isThisDeptNavOpen && (globalNavigation === GlobalNavigation.PROGRESSIVE_DISCLOSURE ? /*#__PURE__*/React.createElement(ProgressiveDisclosureMegaNav, {
    columns: columns,
    departmentTitle: department.title,
    departmentUrl: department.url
  }) : /*#__PURE__*/React.createElement(MegaNav, {
    columns: columns
  })));
};
var _StyledLi = _styled("li")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "DepartmentsNavItem___StyledDiv",
  componentId: "sc-12t7z7q-0"
})(["", ""], visuallyHidden);